// extracted by mini-css-extract-plugin
export default {"iconsWrapper":"SocialIcons_iconsWrapper__y8tOo","icon":"SocialIcons_icon__9W1La"};